import type { AuthorInfo, SearchArticleMeta } from "@serophin/nottldr-shared";
import { ArticleCard } from "../../../components/article/ArticleCard";
import { ExploreLink } from "./Buttons";
import { Section, SectionHeading } from "./Section";
import { Strip } from "./Strip";

type PopularProps = { metas: SearchArticleMeta[]; authors: Record<string, AuthorInfo> };

export const Popular = ({ metas, authors }: PopularProps) => (
  <Section class="bg-white dark:bg-neutral-950/40">
    <SectionHeading title="See what everyone is reading" intro="Tap any card to dive in. No sign-up needed, and every one can be listened to." />
    <Strip>
      {metas.map((meta, index) => (
        <ArticleCard key={meta.id} meta={meta} author={authors[meta.authorAlias]} class="h-full" priority={index === 0} />
      ))}
    </Strip>
    <div class="mt-6 text-center">
      <ExploreLink href="/articles" label="Browse all articles" testId="explore-articles" />
    </div>
  </Section>
);
